var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottery3d-right"},[_c('lottery-info',{}),_c('lottery-betting',{staticClass:"w-100"}),_c('ResultsStatement')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }